/* tslint:disable */
import * as Types from '../../../../../../graphql-api/baskets-api-interfaces';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetBasketManagerListQueryVariables = Types.Exact<{
  query?: Types.InputMaybe<Types.BasketManagerListRequest>;
}>;


export type GetBasketManagerListQuery = { getBasketManagerList?: { page: number, size: number, total: number, data: Array<{ basketId: string, status?: Types.BasketStatus | null, lastUpdatedUtc?: any | null, checkOrderExpiryUtc?: any | null, orderReferenceNumber?: string | null, clientReferenceNumber?: string | null, orderType?: Types.OrderType | null, quantity: number, value: number, net: number, rrp: number, wsp: number, currency?: string | null, isMerged: boolean, hasDiscount: boolean, createdBy: { displayName?: string | null, userName?: string | null, profilePictureUrl?: string | null, id: string }, submittedBy?: { displayName?: string | null, userName?: string | null, profilePictureUrl?: string | null, id: string } | null, brands: Array<{ id: string, name?: string | null, logoUrl?: string | null }>, addresses: Array<{ addressId?: string | null, externalId?: string | null, name?: string | null, street?: string | null, box?: string | null, zipCode?: string | null, city?: string | null, country?: string | null, countryCode?: string | null, state?: string | null, stateCode?: string | null, isDropship: boolean, account: { accountId: string, name?: string | null, domainId?: string | null, externalId?: string | null } }> }> } | null };

export type UserInfoFragment = { displayName?: string | null, userName?: string | null, profilePictureUrl?: string | null, id: string };

export const UserInfoFragmentDoc = gql`
    fragment userInfo on UserExtended {
  displayName
  userName
  profilePictureUrl
  id
}
    `;
export const GetBasketManagerListDocument = gql`
    query GetBasketManagerList($query: BasketManagerListRequest) {
  getBasketManagerList(query: $query) {
    page
    size
    total
    data {
      basketId
      status
      lastUpdatedUtc
      checkOrderExpiryUtc
      orderReferenceNumber
      clientReferenceNumber
      orderType
      createdBy {
        ...userInfo
      }
      submittedBy {
        ...userInfo
      }
      status
      quantity
      value
      net
      rrp
      wsp
      currency
      brands {
        id
        name
        logoUrl
      }
      addresses {
        account {
          accountId
          name
          domainId
          externalId
        }
        addressId
        externalId
        name
        street
        box
        zipCode
        city
        country
        countryCode
        state
        stateCode
        isDropship
      }
      isMerged
      hasDiscount
    }
  }
}
    ${UserInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBasketManagerListGQL extends Apollo.Query<GetBasketManagerListQuery, GetBasketManagerListQueryVariables> {
    document = GetBasketManagerListDocument;
    client = 'baskets';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }